var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.672656 0.683986 0 1.52526 0H5.33843V3C5.33843 3.41484 5.67923 3.75 6.10106 3.75H9.15159V10.5C9.15159 11.3273 8.4676 12 7.62632 12H1.52526C0.683986 12 0 11.3273 0 10.5V1.5ZM9.15159 3H6.10106V0L9.15159 3Z",
    fill: "#969998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.e0066286cdacdb774a885a4fd4e6d8b8.svg";
export { ForwardRef as ReactComponent };